<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" >
          <v-switch color="primary" label="Habilitado?" v-model="userData.isEnabled" ></v-switch>
        </v-col>
        <v-col cols="3" >
          <v-subheader>Tipo de usuario</v-subheader>
        </v-col>
        <v-col cols="3">
          <v-select
            v-bind:items="items"
            label="Select"
            single-line
            bottom
            v-model="userData.userType"
          >
          </v-select>
        </v-col>
        <v-col cols="12">
          asdlaks
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'user-rights-form',
  data () {
    return {
      items: ['GLOBAL', 'NORMAL', 'SUPERVISOR']
    }
  },

  props: ['userData', 'userSubscriptions']
}
</script>



// WEBPACK FOOTER //
// src/components/users/user-rights-form.vue